import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FacebookIcon from '@material-ui/icons/Facebook';
import LanguageIcon from '@material-ui/icons/Language';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import { images } from 'assets/images';
import { COLOR } from 'config/constants';
import { Broker } from 'models';

const useStyles = makeStyles({
  content: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  white_icon: {
    marginRight: 10,
    width: 20,
    height: 20,
    color: COLOR.WHITE,
    alignSelf: 'center',
  },
  dark_icon: {
    marginRight: 10,
    width: 20,
    height: 20,
    color: COLOR.BLACK,
    alignSelf: 'center',
  },
  socialMediaIconContent: {
    alignSelf: 'center',
    cursor: 'pointer',
  },
  icon: {
    marginRight: 5,
    width: 30,
    height: 30,
    alignSelf: 'center',
    cursor: 'pointer',
  },
});

interface Props {
  className?: string;
  portal_infos: any;
  broker: Broker;
  show_white_icons?: boolean;
}

function SocialMediaIcons({ className, portal_infos, broker, show_white_icons }: Props) {
  const styles = useStyles();

  const iconStyle = show_white_icons ? styles.white_icon : styles.dark_icon;
  return (
    <Box className={classNames(className, styles.content)}>
      {portal_infos.youtube ? (
        <Box
          className={styles.socialMediaIconContent}
          onClick={() => {
            return window.open(portal_infos.youtube, '_blank');
          }}
        >
          <YouTubeIcon className={iconStyle} />
        </Box>
      ) : null}
      {portal_infos.twitter ? (
        <Box
          className={styles.socialMediaIconContent}
          onClick={() => {
            return window.open(portal_infos.twitter, '_blank');
          }}
        >
          <img
            src={show_white_icons ? images.x_logo_white : images.x_logo_black}
            alt='x logo'
            width={15}
            height={15}
            style={{ marginRight: 10 }}
          />
        </Box>
      ) : null}
      {portal_infos.instagram ? (
        <Box
          className={styles.socialMediaIconContent}
          onClick={() => {
            return window.open(portal_infos.instagram, '_blank');
          }}
        >
          <InstagramIcon className={iconStyle} />
        </Box>
      ) : null}
      {portal_infos.facebook ? (
        <Box
          className={styles.socialMediaIconContent}
          onClick={() => {
            return window.open(portal_infos.facebook, '_blank');
          }}
        >
          <FacebookIcon className={iconStyle} />
        </Box>
      ) : null}
      {portal_infos.linkedin ? (
        <Box
          className={styles.socialMediaIconContent}
          onClick={() => {
            return window.open(portal_infos.linkedin, '_blank');
          }}
        >
          <LinkedInIcon className={iconStyle} />
        </Box>
      ) : null}
      {portal_infos.tiktok ? (
        <Box
          className={styles.socialMediaIconContent}
          onClick={() => {
            return window.open(portal_infos.tiktok, '_blank');
          }}
        >
          <img
            src={show_white_icons ? images.tiktok_white : images.tiktok_black}
            alt='tiktok icon'
            height={15}
            width={15}
            style={{ marginRight: 10 }}
          />
        </Box>
      ) : null}
      {portal_infos.website || broker.centrisWebsite ? (
        <Box
          className={styles.socialMediaIconContent}
          onClick={() => {
            return window.open(portal_infos.website || broker.centrisWebsite, '_blank');
          }}
        >
          <LanguageIcon className={iconStyle} />
        </Box>
      ) : null}
    </Box>
  );
}

export default SocialMediaIcons;
